import RemoteEvaluateRequest from "../../../../mode/remote/RemoteEvaluateRequest"
import RemoteConfigEvaluateRequest from "../../RemoteConfigEvaluateRequest"
import { HackleUser, MatchValueType } from "../../../../../model/model"
import WorkspaceEvaluation from "../../../../../workspace/evaluation/WorkspaceEvaluation"
import RemoteConfigParameterRemoteEvaluateResult from "../../../../../workspace/evaluation/entity/RemoteConfigParameterRemoteEvaluateResult"

export default class RemoteConfigRemoteEvaluateRequest implements RemoteEvaluateRequest, RemoteConfigEvaluateRequest {
  private constructor(
    readonly workspace: WorkspaceEvaluation,
    readonly entity: RemoteConfigParameterRemoteEvaluateResult,
    readonly user: HackleUser,
    readonly record: boolean,
    readonly requiredType: MatchValueType
  ) {}

  toString(): string {
    return `RemoteConfigRemoteEvaluateRequest(key=${this.entity.key})`
  }

  static of(
    workspace: WorkspaceEvaluation,
    user: HackleUser,
    entity: RemoteConfigParameterRemoteEvaluateResult,
    requiredType: MatchValueType,
    record = true
  ): RemoteConfigRemoteEvaluateRequest {
    return new RemoteConfigRemoteEvaluateRequest(workspace, entity, user, record, requiredType)
  }
}
